import React from "react";
import {Nullable} from "../caos-def";
import {CaosLib} from "../utils.caosdef";
import {variantsIntersect} from "../utils.variants";


const commandLinkRegex = /^\[((?:(?:(?:(?:rl|r|l|lr)?-?v(?:alue)?|(?:rl|r|l|lr))|c(?:ommand)?):)?(?:[A-Z0-9_$][A-Z0-9_$#:+]{3}(?:\s+[A-Z0-9_$#:+]{4})*))]$/gi


type CommandLinkParams = {
    readonly caosLib: CaosLib;
    readonly link: string;
    readonly variants: number;
    readonly pushPopupItem: (kind: string, id: number) => void;
}

/**
 * @constructor
 */
export default function CommandLink({caosLib, link, variants, pushPopupItem: _pushPopupItem}: CommandLinkParams) {

    const parts = commandLinkRegex
        .exec(link)

    if (parts == null) {
        return <>link</>;
    }

    // noinspection SpellCheckingInspection
    const rawCommandType = parts[1]
        ?.split(/-/i, 2)[0]
        ?.replace(/-?(alue|ommand)/gi, "")
        ?.trim();

    const isCommand: Nullable<boolean> = rawCommandType != null ? rawCommandType[0] === "c" : null;
    const isRLValue = rawCommandType[0] == "v";
    const rvalue = (rawCommandType != null && !isRLValue) ? rawCommandType.indexOf("r") >= 0 : null;
    const lvalue = (rawCommandType != null && !isRLValue) ? rawCommandType.indexOf("l") >= 0 : null;

    const command = parts[1];
    let commandId: Nullable<number> = null;
    const onClick = (e: React.MouseEvent) => {
        e.preventDefault();

        if (commandId) {
            _pushPopupItem("command", commandId);
            return;
        }

        if (isCommand === true) {
            commandId = caosLib.getCommands()
                .find(c => {
                    if (!variantsIntersect(variants, c.variants)) {
                        return false;
                    }
                    return c.command === command.toUpperCase() && c.return_type_id === 8
                })
                ?.id;
        } else if (isCommand === false) {
            commandId = caosLib.getCommands()
                .find(c => {
                    if (!variantsIntersect(variants, c.variants)) {
                        return false;
                    }
                    return c.command === command.toUpperCase() && c.return_type_id !== 8
                })
                ?.id;
        }

        if (!commandId) {
            commandId = caosLib.getCommand(command)?.id;
        }

        if (commandId) {
            _pushPopupItem("command", commandId);
        } else {
            console.warn("Failed to find command with name: " + link);
        }
    }

    return <a href="#"
              className="command-link"
              onClick={onClick}
              data-command={command}
              data-is-command={isCommand}
              data-is-lvalue={lvalue}
              data-is-rvalue={rvalue}
              data-is-value={isRLValue}
    >{link}</a>
}